// Legacy RE/MAX contract anchors. Descendants also receive studioReportsOnly
// from the server's feature-access resolution when their session is refreshed.
const REMAX_ORG_IDS = new Set(['6a4ead8843cdd7126d88d6f3', '6a4ead8843cdd7126d88d6f9']);

export function isRemaxStudioAccount(user) {
    if (!user || String(user.role || '').toLowerCase() === 'admin') return false;
    if (String(user.brand || '').toLowerCase() === 'remax') return true;
    return [user._id || user.id, user.agencyId, user.enterpriseId]
        .some((id) => id && REMAX_ORG_IDS.has(String(id)));
}

export function isStudioReportsOnly(user) {
    if (!user || String(user.role || '').toLowerCase() === 'admin') return false;
    return !!user.featureAccess?.studioReportsOnly || isRemaxStudioAccount(user);
}
